// removed by extract-text-webpack-plugin
module.exports = {"box":"_3ilPRj-MAAma3e6FfjQmso","boxContent":"T5o_VJNy9Fmn5dYKLX3fE","main":"_1lmo4cIm3viylaroiggfgx","sub":"S35pt2OM84KkXb0iJdwEh","boxChild":"_3PxkVKKiFNbmn9fV3VRo8X","imgService":"zYfRgABbKQO2mPLnwGFFF","imgOptionBox":"uv_XKS_T2sY83AZKUTcn0"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Common/Booking/PreviewLabel.scss
// module id = 450
// module chunks = 0